import { useEffect, useState } from 'react';
import logo from '../Assets/logo.png';
import '../index.css';
// import mobileData from '../GuideData/mobileData';
// import webData from '../GuideData/webData';
import { 
  clientData,
  ClientMainScreen,
  Profile, 
  StartServiceRequest,
  StartQuoteRequest,
  ClientRequestGeneral,
  ClientRequestLocation,
  TypeOfService,
  ServiceDetails,
  QuoteDetails,
  ClientSubmit,
  PrivacyPolicy,
  DeletionPolicy,
  TermsOfUse,
} from '../GuideData/clientData';

import {
  useParams,
} from "react-router-dom";

const GuidePage = () => {
  const [selectedHeading, setSelectedHeading] = useState(null);
  const [selectedSubheading, setSelectedSubheading] = useState(null);
  const [selectedApp, setSelectedApp] = useState('client'); // web or mobile or client
  const [selectedData, setSelectedData] = useState(clientData);

  let { id } = useParams();
  console.log(decodeURI(id))
  useEffect(()=>{
    if(id === 'privacypolicy'){
      setSelectedApp('client')
      setSelectedData(clientData)
      setSelectedHeading("Privacy & Terms");
      setSelectedSubheading("Privacy Policy");
    }
    if(id === 'deletionpolicy'){
      setSelectedApp('client')
      setSelectedData(clientData)
      setSelectedHeading("Privacy & Terms");
      setSelectedSubheading("Deletion Policy");
    }
    if(id === 'termsofuse'){
      setSelectedApp('client')
      setSelectedData(clientData)
      setSelectedHeading("Privacy & Terms");
      setSelectedSubheading("Terms of Use");
    }
  },[id])

  return (
    <div className="userguide">
      {/* Title */}
      <div className="title-bar">
        <img src={logo} className="logo" alt="Vite logo" width="150" />
        <h3 style={{ marginLeft: '20px'}}>App User Guide<span style={{fontSize: 'large'}}> - Version 1.1 (03/24/2024)</span></h3>
      </div>
      {/* App Selection */}
      <div className='app-selection'>
        <div
          className={`app-option ${selectedApp === 'client' ? 'selected' : ''}`}
          onClick={() => {
            setSelectedApp('client')
            setSelectedData(clientData)
            setSelectedHeading(null);
            setSelectedSubheading(null);
          }}
        >CLIENTS</div>
      </div>
      <div className="content-container">
        {/* Sidebar */}
        <div className="sidebar">
          {selectedData.map(({ heading, subheadings }, index) => (
            <div key={index}>
              {/* Heading */}
              <div
                className={`sidebar-item ${selectedHeading === heading ? 'selected' : ''}`}
                onClick={() => {
                  setSelectedHeading(selectedHeading === heading ? null : heading);
                  setSelectedSubheading(null); // Reset subheading when heading is clicked
                }}
              >
                {heading}
              </div>
              {/* Subheadings */}
              {selectedHeading === heading && (
                <ul style={{ listStyleType: 'none', paddingLeft: '20px', userSelect: 'none' }}>
                  {subheadings.map((subheading, subIndex) => (
                    <li
                      key={subIndex}
                      style={{
                        cursor: 'pointer',
                        fontWeight: selectedSubheading === subheading ? 'bold' : 'normal',
                        color: selectedSubheading === subheading ? '#2596be' : '#000000',
                        marginBottom: '5px',
                      }}
                      onClick={() => setSelectedSubheading(selectedSubheading === subheading ? null : subheading) }
                    >
                      {subheading}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>

        {/* Main Content */}
        <div className="main-content">
          <h3>{selectedSubheading || selectedHeading || <Intro/>}</h3>
          {selectedHeading && !selectedSubheading && (
            <p>
              {/* Display preliminary information for the selected heading */}
              {selectedData.find((data) => data.heading === selectedHeading)?.preliminaryInfo}
            </p>
          )}
          {selectedSubheading && (
            <div>
              {/* Display information for the selected subheading */}
              {/* selectedApp options are client, mobile, app */}
              {selectedSubheading === 'Installation' && <Installation />}
              {selectedSubheading === 'General' && selectedHeading === 'FAQ' && <FAQGeneral />}
              {selectedSubheading === 'Troubleshooting' && selectedHeading === 'FAQ' && <FAQTroubleShooting />}
              {selectedSubheading === 'Main Screen' && selectedApp === 'client' && <ClientMainScreen />}
              {selectedSubheading === 'Profile' && selectedApp === 'client' && <Profile />}
              {selectedSubheading === 'Start a Service Request' && selectedApp === 'client' && <StartServiceRequest />}
              {selectedSubheading === 'Start a Quote Request' && selectedApp === 'client' && <StartQuoteRequest />}
              {selectedSubheading === 'General' && selectedApp === 'client' && (selectedHeading === 'Request for Service' || selectedHeading === 'Request for Quote') && <ClientRequestGeneral />}
              {selectedSubheading === 'Location' && selectedApp === 'client' && <ClientRequestLocation />}
              {selectedSubheading === 'Type of Service' && selectedApp === 'client' && selectedHeading === 'Request for Service' && <TypeOfService />}
              {selectedSubheading === 'Details' && selectedApp === 'client' && selectedHeading === 'Request for Service' && <ServiceDetails />}
              {selectedSubheading === 'Details' && selectedApp === 'client' && selectedHeading === 'Request for Quote' && <QuoteDetails />}
              {selectedSubheading === 'Submit Request' && selectedApp === 'client' && <ClientSubmit />}
              {selectedSubheading === 'Privacy Policy' && selectedApp === 'client' && <PrivacyPolicy />}
              {selectedSubheading === 'Deletion Policy' && selectedApp === 'client' && <DeletionPolicy />}
              {selectedSubheading === 'Terms of Use' && selectedApp === 'client' && <TermsOfUse />}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const Intro = ()=>{
  return(
    <div>
      <div>Welcome to The Proven Group User Guide</div>
      <div style={{fontWeight: 'normal', fontSize: 'smaller'}}>Please make a selection</div>
    </div>
  );
};

const Installation = ()=>{
  return(
    <div>
      <ul>
        <li>Currently this app is by invite only</li>
        <li>You will receive an email from The Proven Group with an install link and instructions</li>
        <li>Coming soon to Apple and Android app stores</li>
      </ul>
    </div>
  );
};

const FAQGeneral = ()=>{
  return(
    <div>
      <div>As this is a new app, FAQ information is currently unavailable. We appreciate your feedback, and if you have any questions, please submit them for consideration.</div>
      <div>info@provengroup.ca</div>
    </div>
  );
};

const FAQTroubleShooting = ()=>{
  return(
    <div>
      <div>As this is a new app, FAQ information is currently unavailable. We appreciate your feedback, and if you have any questions, please submit them for consideration.</div>
      <div>info@provengroup.ca</div>
    </div>
  );
};

export default GuidePage;

/**
 * <div> | </div>
        <div
          className={`app-option ${selectedApp === 'mobile' ? 'selected' : ''}`}
          onClick={() => {
            setSelectedApp('mobile')
            setSelectedData(mobileData)
            setSelectedHeading(null);
            setSelectedSubheading(null);
          }}
        >TECHNICIANS</div>
        <div> | </div>
        <div
          className={`app-option ${selectedApp === 'web' ? 'selected' : ''}`}
          onClick={() => {
            setSelectedApp('web')
            setSelectedData(webData)
            setSelectedHeading(null);
            setSelectedSubheading(null);
          }}
        >ADMIN WEB PORTAL</div>
 */